import React, { useState, lazy } from 'react';
import Space from 'components/barbr/Space/index';
import { GiftIcon } from 'components/Icon';
import { useHistory } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

import { isEmpty } from '_dash';
import { LOGIN_ROUTE } from 'appRoutes/routeConstants';
import { getProfileRoute } from 'appRoutes/routeHelpers';

import './style.scss';

const ReferFriend = lazy(() => import('../refer/index'));

const RefererItem = ({ referrral, isLoggedIn, username }) => {
  const history = useHistory();
  const [modalVisible, setModalVisible] = useState(false);

  const onClickReferItem = () => {
    if (isLoggedIn) {
      setModalVisible(true);
    } else {
      history.push({
        pathname: LOGIN_ROUTE,
        ...(username
          ? {
              state: { username: username },
              search: `?next=${getProfileRoute(username)}`,
            }
          : {}),
      });
    }
  };

  const handleReferItem = () => onClickReferItem();

  const closeModal = () => setModalVisible(false);

  return (
    <>
      <If condition={!isEmpty(referrral)}>
        <div className='referer-item' onClick={handleReferItem}>
          <Space size={12} align='center'>
            <GiftIcon size={38} />
            <p className='text-xl primary bold'>Get £{referrral.existing_client_reward_amount} off your booking</p>
          </Space>
        </div>
        <Modal show={modalVisible} fullscreen='sm-down' onHide={closeModal}>
          <ReferFriend onBack={closeModal} />
        </Modal>
      </If>
    </>
  );
};

export default RefererItem;
